export default __webpack_public_path__ + "static/media/M10 - Crimson Wolf.d8d52cf7.png";